export enum AssetInventorySidebarFilterFieldEnum {
  resource_category = 'resource_category',
  resource_type = 'resource_type',
  resource_type_label = 'resource_type_label',
}

export const CQ_ALIAS_PREFIX = '';
